import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import produce from 'immer'
import { useQuery, useQueryClient } from 'react-query'
import { UseQueryOptions } from 'react-query/types/react/types'
import { useDispatch } from 'react-redux'
import * as Actions from 'redux/actions'
import { useRootStore } from 'stores/RootStore'
import { AlmanacFileSummary, ArticleFlat } from 'types'
import { articlesKeys } from '../articles/articlesKeys'
import { almanacFileKeys } from './almanacFileKeys'

export interface AlmanacFileData {
  almanac_file: AlmanacFileSummary
}

export const useAlmanacFile = (
  key: string,
  options?: Omit<UseQueryOptions<AlmanacFileData>, 'queryKey' | 'queryFn'>,
) => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const rootStore = useRootStore()

  return useQuery<AlmanacFileData>(
    almanacFileKeys.detail(key),
    async () => {
      const response = await sendToApi<AlmanacFileData>(`/almanac_files/${key}`, {
        params: { include: ['version_control_mode.metadata'] },
      })
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }

      rootStore.files.add(response.data.almanac_file)
      dispatch(Actions.articleMetaUpsert({ id: key, almanac_file: response.data.almanac_file }))
      queryClient.setQueriesData<{ article: ArticleFlat } | undefined>([articlesKeys.prefix, 'detail', key], (old) => {
        return produce(old, (draft) => {
          if (!draft) {
            return
          }

          draft.article.almanac_file = response.data.almanac_file
        })
      })

      return response.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
